import React, { useEffect, useState } from 'react';
import { TrendingUp } from 'lucide-react';
import api from '../lib/api';

/**
 * Tiny live-counter pill: "324 UK businesses signed up this week".
 * Falls back to a credible floor (set on the backend) if the install is brand-new.
 */
const SignupCount = ({ className = '', testid = 'signup-count' }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await api.get('/public/signup-count');
        if (alive) setData(res.data);
      } catch {
        /* silent — analytics, not critical */
      }
    })();
    return () => { alive = false; };
  }, []);
  if (!data) return null;
  return (
    <div
      data-testid={testid}
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-50 border border-emerald-200 text-emerald-800 text-xs font-semibold ${className}`}
    >
      <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
      <TrendingUp className="w-3.5 h-3.5" />
      <span>
        <span data-testid="signup-count-value">{data.displayLast7d}</span> UK businesses joined this week
      </span>
    </div>
  );
};

export default SignupCount;
